import ButtonAction from '../../../../../components/buttons/ButtonAction';
import SearchSimple from '../../../../../components/SearchSimples/SearchSimple';
import React from 'react';
import {permissionObj} from '../../../../../Helpers/permission';
import {SUB_VIEW_MODEL} from '../../Model/Models';

const ScheduleHeader = (props) => {
    const {
        optionView,
        handleBtnShifts,
        handleBtnMeals,
        handleBtnAccessCode,
        searchId,
        setBodyForExport,
        setSearchResults,
        searchElement,
        setSearchElement,
        option,
        rowsPerPage,
        setSimpleSearch,
        search,
        setSearch,
        permission,
        DEV
    } = props;

    return(
        <div className='d-flex'>
            <div className='d-flex gap-3'>
                { (DEV || permission?.includes(permissionObj?.WEB_FOODIE_SHIFT_READ) ) &&
                    <ButtonAction
                        id='btn_sh_shifts'
                        name='shifts'
                        className={SUB_VIEW_MODEL.SCHEDULE.SHIFTS === optionView ? 'btn-outlined-secondary-600-100' : 'btn-outlined-secondary-600-00'}
                        disabled={false}
                        splitName={false}
                        onClick={() => {
                            handleBtnShifts()
                        }}
                    />
                }

                { (DEV || permission?.includes(permissionObj?.WEB_FOODIE_MEAL_TIME_READ) ) &&
                    <ButtonAction
                        id='btn_sh_service_time'
                        name='service_time'
                        className={SUB_VIEW_MODEL.SCHEDULE.MEALS === optionView ? 'btn-outlined-secondary-600-100' : 'btn-outlined-secondary-600-00'}
                        disabled={false}
                        splitName={false}
                        onClick={() => {
                            handleBtnMeals();
                        }}
                    />
                }

                { (DEV || permission?.includes(permissionObj?.WEB_FOODIE_ACCESS_READ) ) &&
                <ButtonAction
                    id='btn_sh_access_code'
                    name='access_codes'
                    className={SUB_VIEW_MODEL.SCHEDULE.ACCESS_CODE === optionView ? 'btn-outlined-secondary-600-100' : 'btn-outlined-secondary-600-00'}
                    disabled={false}
                    splitName={false}
                    onClick={() => {
                        handleBtnAccessCode();
                    }}
                />
                }
            </div>
            <div className='w-100 ml-4'>
                <SearchSimple
                    id={searchId}
                    setBodyForExport={setBodyForExport}
                    setSearchResults={setSearchResults}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    optionTable={option}
                    rowsPerPage={rowsPerPage}
                    setSimpleSearch={setSimpleSearch}
                    search={search}
                    setSearch={setSearch}
                    contractorId={null}
                    supplierId={null}
                />
            </div>
    </div>)
}

export default ScheduleHeader;
